import { logger } from './logger';

type ReturnedErrorLogLevel = 'info' | 'warn' | 'error';

const USER_INPUT_ERROR_CODES = new Set([
    'phone_code_invalid',
    'validation_error',
    'payload_parse_exception',
]);

const EXPECTED_BUSINESS_OUTCOME_CODES = new Set([
    'deal_expired',
    'deal_not_started',
    'deal_already_claimed',
    'deal_already_redeemed',
    'phone_already_verified',
    'customer_merchant_exception',
    'customer_not_found',
    'phone_not_available',
    'customer_to_young',
    'dob_update_to_frequent',
    'phone_verified_too_many_times',
    'phone_number_has_unsubscribed',
    'merchant_not_found',
    'deal_not_found',
    'merchant_group_without_sub_locations',
]);

const SERVER_ERROR_CODES = new Set(['internal_server_error', 'api_exception']);

export function normalizeReturnedErrorCode(error: unknown): string | undefined {
    if (typeof error === 'string') {
        return error;
    }

    if (
        error !== null &&
        typeof error === 'object' &&
        'error' in error &&
        typeof (error as { error: unknown }).error === 'string'
    ) {
        return (error as { error: string }).error;
    }

    return undefined;
}

export function getReturnedErrorLogLevel(
    error: unknown
): ReturnedErrorLogLevel {
    const code = normalizeReturnedErrorCode(error);
    if (code === undefined) {
        return 'warn';
    }
    if (USER_INPUT_ERROR_CODES.has(code)) {
        return 'info';
    }
    if (SERVER_ERROR_CODES.has(code)) {
        return 'error';
    }
    if (EXPECTED_BUSINESS_OUTCOME_CODES.has(code)) {
        return 'warn';
    }
    return 'warn';
}

export function logReturnedError(
    message: string,
    context: string,
    data: Record<string, unknown> & { error: unknown }
): void {
    const level = getReturnedErrorLogLevel(data.error);

    switch (level) {
        case 'info':
            logger.info(message, context, data);
            break;
        case 'warn':
            logger.warn(message, context, data);
            break;
        case 'error':
            logger.error(message, context, data);
            break;
    }
}
